import { Component, input } from '@angular/core';

type TheftStatus = 'has-theft' | 'no-theft';

@Component({
  selector: 'app-pan-theft-status',
  templateUrl: './pan-theft-status.component.html',
  styleUrl: './pan-theft-status.component.scss',
  standalone: false,
})
export class PanTheftStatusComponent {
  public status = input.required<TheftStatus>();
}
